import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import type React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors/ui/ui';
import { getDisplayName } from 'utils/getDisplayName/getDisplayName';

const WithFlysiteUrls = <P extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<P & FlysiteUrls>,
) => {
  const WithFlysiteUrls = (props: P) => {
    const locale = useSelector(getCurrentLocale);
    const urls = useFlysiteUrls(locale);
    return <WrappedComponent {...props} {...urls} />;
  };

  WithFlysiteUrls.displayName = `WithFlysiteUrls(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithFlysiteUrls;
};

export { WithFlysiteUrls };
